import { getDoctorDashboard } from "./DoctorDashboardActions";
import {
  showLoader,
  hideLoader,
  showSnackbar,
} from "../../utilities/UtilitiesActions";
import HttpRequest from "../../utilities/httpRequest";

export const getDoctorDashboardRequest = (doctorId, date) => {
  return (dispatch) => {
    dispatch(showLoader());

    const url = `users/${doctorId}/appointments?date=${date}`;

    return new HttpRequest(dispatch, url, "get").send().then(
      (res) => {
        dispatch(hideLoader());

        const dashboardData = res.data.data;
        dispatch(getDoctorDashboard(dashboardData));

        return Promise.resolve(dashboardData);
      },
      (error) => {
        dispatch(hideLoader());
        const errorMessage =
          error.response?.data?.error ||
          "Failed to fetch doctor dashboard data";
        dispatch(showSnackbar(errorMessage, "error"));
        return Promise.reject(error);
      }
    );
  };
};
